import React from "react";

export const AccountLinkingContext = React.createContext();